import { render, staticRenderFns } from "./AddExpertDialog.vue?vue&type=template&id=5a2ba872&scoped=true"
import script from "./AddExpertDialog.vue?vue&type=script&lang=js"
export * from "./AddExpertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ba872",
  null
  
)

export default component.exports